export default class LoginInfo {
    constructor() {
        return {
            template: require('../../../../views/login/organisms/o-login-info.html'),
            controller: LoginInfoController,
            controllerAs: 'loginInfo'
        }
    }
}

class LoginInfoController {
    constructor($element) {
        this.$onInit = () => {
           $element.addClass('o-login-info');
        }
    };
}

